import type { SyntheticEvent } from 'react';
import React from 'react';

import { LayoutItem } from '../Layout/LayoutItem';
import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { Layout } from '../Layout/Layout';

export type TileProps = {
  Badge?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  /**
   * Saves what `href` points at under this name rather than going there. Needs an `href`, which is
   * a plain anchor and not a route: a tile standing for a file owes the reader the browser's own
   * save - middle-click, right-click, keyboard - which no handler can give them.
   */
  download?: string;
  href?: string;
  name?: string;
  onClick?: (e: SyntheticEvent) => void;
  selected?: boolean;
};
export const TilesItem = ({
  Badge,
  children,
  className,
  disabled,
  download,
  href,
  name,
  onClick,
  selected,
}: TileProps) => {
  // A disabled tile keeps its face but loses its href, which is what makes an anchor inert.
  const isLink = !!href && !disabled;

  const tileClassName = AttrsHelper.formatClassname(
    'tile',
    'stretchable',
    disabled && 'disabled',
    (onClick || isLink) && 'selectable',
    selected && 'selected',
    className
  );

  const body = (
    <Layout
      reversibleOn="smallScreen"
      stackableOn="smallScreen"
      verticalGutter="8px"
    >
      <LayoutItem className="tile-label" fluid hug>
        {children}
      </LayoutItem>
      {!!Badge && <div className="header-badge">{Badge}</div>}
    </Layout>
  );

  return isLink ? (
    <a
      className={tileClassName}
      data-test={name}
      download={download}
      href={href}
      onClick={onClick}
    >
      {body}
    </a>
  ) : (
    <div
      className={tileClassName}
      data-test={name}
      onClick={disabled ? undefined : onClick}
    >
      {body}
    </div>
  );
};
